import type { FaqItem } from "@/types/media";

export const faqList: FaqItem[] = [
  {
    id: "f1",
    question: "光棍影院可以免费观看吗？",
    answer:
      "本站所有浏览、搜索、筛选、剧情介绍与收藏功能均完全免费，游客无需登录注册即可使用全部功能，也不收取任何费用。",
  },
  {
    id: "f2",
    question: "网站上的影片可以直接在线播放吗？",
    answer:
      "当前站点为内容展示与体验演示，播放按钮仅为交互演示效果，暂未接入真实的播放接口，不提供实际视频播放。后续如有播放需求可另行接入。",
  },
  {
    id: "f3",
    question: "收藏的内容会保存在哪里？",
    answer:
      "收藏功能基于浏览器本地存储（LocalStorage）实现，仅保存在当前设备与当前浏览器中。清除浏览器数据或更换设备后，收藏记录不会同步。",
  },
  {
    id: "f4",
    question: "如何快速找到想看的影片？",
    answer:
      "你可以使用顶部搜索框按片名、主演或导演关键词搜索；也可以进入电影或电视剧分类页，通过类型、地区、年份等多维度筛选，并按更新时间、热度或评分排序。",
  },
  {
    id: "f5",
    question: "网站内容会持续更新吗？",
    answer:
      "「最新更新」和「热门推荐」板块会动态展示站点内的更新内容与高热度作品。本演示站使用示例数据，实际运营时可由后台持续维护更新。",
  },
  {
    id: "f6",
    question: "影片评分和热门标签是怎么来的？",
    answer:
      "评分与热门标签均为站内示例数据，用于展示信息结构与交互效果，不代表任何真实评价、排名或奖项，仅供参考体验。",
  },
  {
    id: "f7",
    question: "发现内容错误或想反馈建议怎么办？",
    answer:
      "欢迎前往「关于我们」页面，通过底部联系反馈表单告诉我们。我们会认真阅读每一条建议，不断优化站点的浏览与筛选体验。",
  },
];